/**
 * FinanceKpiWidget — Lecture seule : factures (payées / en attente / en retard).
 * Source : GET /api/invoices/stats/summary
 */
import { useEffect, useState } from "react";
import { api } from "@/api";
import { Wallet, CheckCircle2, Clock, AlertTriangle } from "lucide-react";

export default function FinanceKpiWidget() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/invoices/stats/summary")
      .then((r) => setData(r.data))
      .catch(() => setData(null));
  }, []);

  if (!data) return <div className="text-center text-gray-400 text-xs py-4">Chargement…</div>;
  const fmt = (n) => Number(n || 0).toFixed(0);
  const byStatus = data.by_status || {};
  const paidCount = byStatus.payee ?? 0;
  const pendingCount = data.pending_count ?? 0;
  const overdueCount = data.overdue_count ?? 0;

  return (
    <div className="grid grid-cols-2 gap-2" data-testid="widget-finance-kpi">
      <Kpi icon={CheckCircle2} value={paidCount} label="Payées" color="emerald" />
      <Kpi icon={Clock} value={pendingCount} label="En attente" color="amber" />
      <Kpi icon={Wallet} value={`${fmt(data.total_paid)} $`} label="Encaissé" color="indigo" />
      <Kpi icon={AlertTriangle} value={overdueCount} label="En retard" color="rose" />
    </div>
  );
}

function Kpi({ icon: Icon, value, label, color }) {
  const tones = {
    emerald: "bg-emerald-50 text-emerald-700 border-emerald-200",
    amber: "bg-amber-50 text-amber-700 border-amber-200",
    indigo: "bg-indigo-50 text-indigo-700 border-indigo-200",
    rose: "bg-rose-50 text-rose-700 border-rose-200",
  };
  return (
    <div className={`rounded-lg border p-2 ${tones[color]}`}>
      <Icon className="w-3.5 h-3.5 mb-1 opacity-70" />
      <div className="text-xl font-bold truncate">{value}</div>
      <div className="text-[10px] opacity-75">{label}</div>
    </div>
  );
}
